<template>
  <div>
    <div class="card no-margin-bottom">
      <div class="card-block">
        <ui-data-table
          id="plans-list"
          ref="list"
          :columns="columns"
          :filters="filters"
          :endpoint="endpoint"
          :actions="actions"
          size="sm"
        >
          <template slot="id" slot-scope="row">
            <router-link
              :to="{ name: 'EditCustomPlan', params: { id: row.id } }"
            >
              {{ row.id }}
            </router-link>
          </template>

          <template slot="created_at" slot-scope="row">
            <span>{{ $getFormattedDate(row.created_at) }}</span>
          </template>

          <template slot="is_active" slot-scope="row">
            <i v-if="row.is_active" class="fa fa-check text-success" />
            <i v-else class="fa fa-remove text-danger" />
          </template>

          <template slot="actions" slot-scope="row">
            <a href="#" class="text-danger" @click.prevent="remove(row.id)">
              <i :title="$t('Delete')" class="fa fa-trash" />
            </a>
          </template>
        </ui-data-table>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import ApiService from "../services/ApiService";
import ErrorsMixins from "../mixins/ErrorsMixins";
import DateFormatFiltersMixin from "../mixins/DateFormatFiltersMixin";
import PlansService from "../services/PlansService";
export default {
  name: "AppPagePlans",
  mixins: [ErrorsMixins, DateFormatFiltersMixin],
  data() {
    return {
      columns: [
        {
          name: "ID",
          key: "id",
          sorting: true,
          styles: "text-right",
        },
        {
          name: this.$tc("Plan name", 1),
          key: "name",
          sorting: true,
        },
        {
          name: this.$tc("Orders", 2),
          key: "options.orders",
          sorting: true,
        },
        {
          name: this.$tc("Users", 2),
          key: "options.users",
          sorting: true,
        },
        // {
        //   name: this.$tc('Marketplaces',2),
        //   key: 'marketplaces',
        //   sorting: true,
        // },
        {
          name: this.$tc("Skus", 2),
          key: "options.skus",
          sorting: true,
        },
        // {
        //   name: this.$tc('Variations',2),
        //   key: 'variations',
        //   sorting: true,
        // },
        {
          name: this.$tc("Price", 1),
          key: "price",
          sorting: true,
        },
        {
          name: this.$tc("Interval", 1),
          key: "interval",
          sorting: true,
        },
        {
          name: this.$t("Date"),
          key: "created_at",
        },
        {
          name: this.$t("Enabled"),
          key: "is_active",
          sorting: true,
          styles: "text-center",
        },
        {
          name: this.$tc("Actions", 2),
          key: "actions",
          styles: "text-center",
        },
      ],
      filters: [
        {
          name: "ID",
          key: "id",
          type: "integer",
        },
        {
          name: this.$tc("Plan name", 1),
          key: "name",
          type: "string",
        },
        {
          name: this.$tc("Orders", 2),
          key: "options.orders",
          type: "integer",
        },
        {
          name: this.$tc("Users", 2),
          key: "options.users",
          type: "integer",
        },
        // {
        //   name: this.$tc('Marketplaces',2),
        //   key: 'marketplaces',
        //   type: 'integer',
        // },
        {
          name: this.$tc("Skus", 2),
          key: "options.skus",
          type: "integer",
        },
        // {
        //   name: this.$tc('Variations',2),
        //   key: 'variations',
        //   type: 'integer',
        // },
        {
          name: this.$tc("Price", 1),
          key: "price",
          type: "integer",
        },
        {
          name: this.$tc("Interval", 1),
          key: "interval",
          type: "string",
        },
        {
          name: this.$t("Date"),
          key: "date",
          type: "string",
        },
      ],
      endpoint: `${ApiService.getLink("billing/plans")}&is_default=0`,
      actions: [
        {
          icon: "fa fa-plus",
          action: () => {
            this.$router.push({ name: "CreateCustomPlan" });
          },
          label: this.$t("Create object", {
            object: this.$tc("Plans", 1).toLowerCase(),
          }),
        },
      ],
    };
  },
  methods: {
    refresh() {
      this.$refs.list.refresh();
    },
    remove(id) {
      // eslint-disable-next-line
      if (confirm(this.$t("Are you sure?"))) {
        this.loading = true;
        PlansService.remove(id)
          .then(() => {
            this.loading = false;
            this.$notifications_success(
              this.$t("Action", {
                object: this.$tc("Plans", 1),
                action: this.$t("deleted"),
              })
            );
            this.refresh();
          })
          .catch(() => {
            this.$errors_showNetworkErrorMessage();
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.role-badge {
  margin-right: 3px;
}
</style>
